import DragAndDrop from './DragAndDrop';

export default {
  __init__: [ 'dragAndDrop' ],
  dragAndDrop: [ 'type', DragAndDrop ]
};